import { render, staticRenderFns } from "./DevMenu.vue?vue&type=template&id=8cb789b4&scoped=true"
import script from "./DevMenu.vue?vue&type=script&lang=ts"
export * from "./DevMenu.vue?vue&type=script&lang=ts"
import style0 from "./DevMenu.vue?vue&type=style&index=0&id=8cb789b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb789b4",
  null
  
)

export default component.exports